export default {
  en: {
    email: 'Email'
  },
  th: {
    email: 'อีเมล'
  }
}
